/* Astronaut kiwi variant — helmet dome + antenna. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderAstronaut(p: KiwiPalette) {
  return (
    <>
      {/* Helmet dome */}
      <path d="M8 2H22V4H24V6H26V12H24V14H22V16H8V14H6V12H4V6H6V4H8V2Z" fill={p.accent} opacity={0.2} />
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />
      {/* Beak inside helmet */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14Z" fill={p.beak} />
      {/* Tuft */}
      <path d="M10 4H12V6H10V4ZM12 2H14V4H12V2Z" fill={p.body} />
      {/* Eye */}
      <rect x="10" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="12" y="12" width="2" height="2" fill={p.pupil} />
      {/* Helmet visor glint */}
      <rect x="6" y="4" width="2" height="2" fill={p.accent} opacity={0.15} />
      {/* Antenna */}
      <rect x="15" y="0" width="2" height="2" fill={p.accent} opacity={0.5} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
